import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

import CommentDialog from "../../../Dialogs/CommentDialog";

interface LockLotButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}

function LockLotButton({ setLoading }: LockLotButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { admin, supervisor } = usePrivileges();

    const { lotDetail: { summary: { lotNumber, currentStatus, isLocked } }, getLotDetail } = useContext(LotDetailContext);

    const [showLockLotCommentDialog, setLockLotCommentDialog] = useState(false);

    const lockLot = async (comment: string) => {
        setLoading(true);

        fetchDataAuthenticated(`api/v1/lot/${lotNumber}/lock`, 'PUT', JSON.stringify(comment))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", `Lot ${lotNumber} is now locked`);
                    getLotDetail();
                } else {
                    let message = await response.text();
                    throw new Error(`Failed to lock the lot. ${message}`);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Button variant="warning"
                hidden={(!admin && !supervisor) || isLocked || currentStatus === "Graded"}
                onClick={() => setLockLotCommentDialog(true)}>
                <FontAwesomeIcon icon={faLock} className="me-1" />
                {t<string>('LotDetails.Summary.LockLot')}
            </Button>
            <CommentDialog
                showDialog={showLockLotCommentDialog}
                closeDialog={() => setLockLotCommentDialog(false)}
                onSave={lockLot} />
        </>
    );
}

export default LockLotButton;